var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _text, _text2, _text3, _text4, _rect7, _rect8, _rect9, _rect0, _text5, _text6, _text7, _text8, _rect1, _rect10, _rect11, _rect12, _text9, _text0, _text1, _text10, _text11, _text12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 300,
    viewBox: "0 0 400 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "#F8FAFC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 300,
    height: 200,
    rx: 8,
    fill: "white",
    stroke: "#E2E8F0",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 60,
    height: 40,
    rx: 4,
    fill: "#3B82F6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 70,
    width: 60,
    height: 40,
    rx: 4,
    fill: "#10B981"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 70,
    width: 60,
    height: 40,
    rx: 4,
    fill: "#F59E0B"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 70,
    width: 60,
    height: 40,
    rx: 4,
    fill: "#EF4444"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 95,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fill: "white",
    fontWeight: "bold"
  }, "2 vCPU")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 95,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fill: "white",
    fontWeight: "bold"
  }, "4 vCPU")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 95,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fill: "white",
    fontWeight: "bold"
  }, "8 vCPU")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 95,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fill: "white",
    fontWeight: "bold"
  }, "16 vCPU")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 120,
    width: 60,
    height: 30,
    rx: 4,
    fill: "#E5E7EB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 120,
    width: 60,
    height: 30,
    rx: 4,
    fill: "#E5E7EB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 120,
    width: 60,
    height: 30,
    rx: 4,
    fill: "#E5E7EB"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 120,
    width: 60,
    height: 30,
    rx: 4,
    fill: "#E5E7EB"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 140,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 10,
    fill: "#6B7280"
  }, "2GB RAM")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 140,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 10,
    fill: "#6B7280"
  }, "8GB RAM")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 140,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 10,
    fill: "#6B7280"
  }, "16GB RAM")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 140,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 10,
    fill: "#6B7280"
  }, "32GB RAM")), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 160,
    width: 60,
    height: 30,
    rx: 4,
    fill: "#F3F4F6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 160,
    width: 60,
    height: 30,
    rx: 4,
    fill: "#F3F4F6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 160,
    width: 60,
    height: 30,
    rx: 4,
    fill: "#F3F4F6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 160,
    width: 60,
    height: 30,
    rx: 4,
    fill: "#F3F4F6"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 180,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 10,
    fill: "#6B7280"
  }, "20GB")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 180,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 10,
    fill: "#6B7280"
  }, "40GB")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 180,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 10,
    fill: "#6B7280"
  }, "80GB")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 310,
    y: 180,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 10,
    fill: "#6B7280"
  }, "160GB")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 220,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fill: "#374151",
    fontWeight: 600
  }, "Flavor Templates")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 240,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fill: "#6B7280"
  }, "Pre-configured compute resources")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.7f85714b29b0c21ebf9788b2daf083e7.svg";
export { ForwardRef as ReactComponent };